// removed by extract-text-webpack-plugin
module.exports = {"Video":"_1iCz8","Detail":"_uXxf5","DetailShortBar":"_1LKKs","DetailLongBar":"_1Spwb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HotelDetail/HotelAbout/HotelAbout.scss
// module id = 925
// module chunks = 0